import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../_metronic/helpers'
import { useQueryRequest } from './QueryRequestProvider'
import { getAtendimentosByPaciente, getAtendimentosOfPaciente } from './_requests'
import { useSearchParams } from 'react-router-dom'
import { AtendimentoPacienteList } from './_models'
import { useModal } from '../../../../components'

const QueryResponseContext = createResponseContext<AtendimentoPacienteList>(initialQueryResponse)
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const [searchParams] = useSearchParams()
  const idPacienteParam = String(searchParams.get('paciente'))

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery(
    `${QUERIES.ATENDIMENTO_MEDICO_LIST}-${query}-${isOpen}`,
    () => {
      if (idPacienteParam !== 'null') {
        return getAtendimentosByPaciente(Number(idPacienteParam), query)
      } else {
        return getAtendimentosOfPaciente(query)
      }
    },
    { cacheTime: 0, keepPreviousData: true, refetchOnWindowFocus: false, enabled: !isOpen }
  )

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
